import { ChevronArrowLeft, ChevronArrowRight } from '@shared/assets/icons/components';
import ReactPaginate from 'react-paginate';

import styles from './paginator.module.scss';
import type { PaginatorProps } from './types';

interface PaginatorInternalProps extends PaginatorProps {
  scrollContainer?: HTMLElement | null;
}

export const Paginator = ({
  initialPage,
  pageCount,
  onPageChange,
  scrollContainer,
}: PaginatorInternalProps) => {
  const forcePage = initialPage ? initialPage - 1 : undefined;

  if (!pageCount || !onPageChange) {
    return null;
  }

  const hasNextPage = forcePage !== undefined && forcePage + 1 < pageCount;
  const hasPreviousPage = forcePage !== undefined && forcePage > 0;

  const handlePageChange = ({ selected }: { selected: number }) => {
    const currentPage = selected + 1;
    onPageChange(currentPage);

    // Scroll to top
    scrollContainer?.scroll?.({
      top: 0,
      behavior: 'instant',
    });
  };

  return (
    <ReactPaginate
      breakLabel="..."
      nextLabel={hasNextPage && <ChevronArrowRight height={16} width={16} />}
      previousLabel={hasPreviousPage && <ChevronArrowLeft height={16} width={16} />}
      forcePage={forcePage}
      onPageChange={handlePageChange}
      pageRangeDisplayed={1}
      pageCount={pageCount}
      renderOnZeroPageCount={null}
      className={styles.root}
      activeLinkClassName={styles.activeLink}
      breakLinkClassName={styles.breakLink}
      pageClassName={styles.page}
      pageLinkClassName={styles.pageLink}
      previousClassName={styles.previous}
      nextClassName={styles.next}
    />
  );
};
